export class NonNegativeIntegerValidator {
	static validate(value: number | undefined) {
		if (value === undefined) return false;
		return Number.isInteger(value) && value >= 0;
	}
}
